module.exports = __webpack_public_path__ + "img/login_icon.06cc867a.png";